import { render, staticRenderFns } from "./activityReferenceInfrastructure.html?vue&type=template&id=5270cfb3&scoped=true&external"
import script from "./activityReferenceInfrastructure.vue?vue&type=script&lang=js"
export * from "./activityReferenceInfrastructure.vue?vue&type=script&lang=js"
import style0 from "./activityReferenceInfrastructure.css?vue&type=style&index=0&id=5270cfb3&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5270cfb3",
  null
  
)

export default component.exports